import {ClientsController} from "../clients_controller";
import moment from "moment/moment";
import {buildExportUrl, exportTableXlsx} from "../../../helpers/tabulator_export_helper";

export default class extends ClientsController {
  // Actions
  exportTable(event) {
    event.stopPropagation();

    this._exportTableXlsx();
  }

  // Private

  // export
  // Export from tabulator
  _exportTableXlsx() {
    let tableTabulator = super._activeTabulator;
    let url = buildExportUrl(tableTabulator);
    let title = "Clients - " + moment().format("YYYY-MM-DD_HH-mm-ss");

    exportTableXlsx(url, tableTabulator, title);
  }
}